<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="520px">
      <custom-modal
        title="Edit Income Category"
        @onSubmit="save"
        @onClose="close"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer">
          <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
            <v-text-field
              v-model="category.name"
              label="Name"
              outlined
              hide-details="auto"
              :error-messages="errors"
              class="mb-4"
            />
          </ValidationProvider>
          <v-text-field v-model="category.code" label="Code" outlined hide-details="auto" class="mb-4" />
          <v-textarea v-model="category.description" label="Description" outlined rows="3" hide-details="auto" />
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import CustomModal from "@/components/base/CustomModal";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { IncomeCategory } from "@/models/IncomeCategory";

extend("required", { ...required, message: "{_field_} is required" });

export default {
  components: { CustomModal, ValidationObserver, ValidationProvider },
  props: {
    visible: { type: Boolean, default: false },
    category: { type: Object, default: () => new IncomeCategory() },
  },
  data: () => ({ isLoading: false }),
  computed: {
    show: {
      get() { return this.visible; },
      set(value) { if (!value) this.$emit("close"); },
    },
  },
  methods: {
    close() { this.show = false; },
    async save() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.isLoading = true;
      this.$store
        .dispatch("sitesetting/EditIncomeCategory", {
          Id: this.category.id,
          data: {
            name: this.category.name,
            code: this.category.code,
            description: this.category.description,
          },
        })
        .then(() => {
          this.$toast.success("Income category updated");
          this.$emit("afterSave");
          this.isLoading = false;
          this.close();
        })
        .catch((err) => {
          this.isLoading = false;
          if (err && err.data && err.data.error) this.$refs.observer.setErrors(err.data.error);
          this.$toast.error("Income category update failed");
        });
    },
  },
};
</script>
